module.exports = __webpack_public_path__ + "static/20180920_174142_optimized-6a755ed4452550929035d4982ac8fa60.jpg";